// extracted by mini-css-extract-plugin
export default {"paper":"styles_paper__GVg3U","container":"styles_container__LFvaZ","list":"styles_list__OiL80"};